var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cms-block',_vm._b({on:{"block-selected":_vm.selectBlock}},'cms-block',_vm.$props,false),[_c('iframe',{style:(_vm.iframeStyle),attrs:{"src":_vm.block.iframe.languageProxy.src}})])
}
var staticRenderFns = []

export { render, staticRenderFns }